<main>
  <router-outlet/>

  @if (!router.url.includes('template-print')) {
    <sf-helper/>
  }

  <ng-template #NofBtnRef let-notification>
    <button
      class="sf-btn-fifth small h-36 w-100"
      style="float: right;"
      (click)="changeLanguage();
      notification.close()">
      <i class="ph-bold ph-check fs-22"></i>
    </button>
  </ng-template>


  <ng-template #CookieTmRef let-notification>
    <div class="ant-notification-notice-content">
      <div class="ant-notification-notice-with-icon">
          <span class="ant-notification-notice-icon mt-4">
            <i class="ph ph-cookie fs-24"></i>
          </span>

        <div class="ant-notification-notice-message fw-600">{{ 'cookie.title' | translate }}</div>

        <div class="ant-notification-notice-description">
          {{ 'cookie.desc' | translate }}

          <a
            (click)="onConfirmCookie(notification)"
            class="sf-link fs-14 ml-2"
            [routerLink]="appStateService.route_paths | lngRoute: 'privacy_policy' : appStateService.dateTime">
            {{ 'cookie.link' | translate }}
          </a>
        </div>

        <button class="sf-btn-primary h-32 fs-14 mt-18" (click)="onConfirmCookie(notification)">
          {{ 'cookie.accept' | translate }}
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #PremiumStudentRef>
    <sf-students-premium-banner/>
  </ng-template>

<!--  <sf-sentry-example/>-->

</main>

